<template>
  <div class="conteudoInterno" id="distribuicao">
    <div class="boxSeta">
      <div
        class="setaScrollstatic"
        style=""
        :class="{
          setaScroll: setaScrollState,
        }"
      >
        <button>
          <span><i class="bottom"></i></span>
        </button>
      </div>
    </div>
    <header class="headerSec">
      <h2>Distribuição</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked">
          <span><i class="left"></i></span>
        </button>
        <button @click="goNext()" :disabled="clicked">
          <span><i class="right"></i></span>
        </button>
      </div>
    </header>
    <div class="conteudoInternoBox" ref="infoBox">
      <section class="sectionRow" ref="infoscroll">
        <div class="col23ponto5 marginColBottom">
          <span class="linecol ubcPinkBack"></span>
        </div>
        <div class="col66 top32">
          <p>
            Embora a concessão de licenças e a arrecadação sejam objetivos e desafios importantes do sistema de gestão coletiva, seu verdadeiro valor deve se traduzir em distribuições efetivas, o que reflete nosso objetivo final: pagar aos detentores dos direitos pelo uso de suas criações. O objetivo é sermos precisos, eficientes, transparentes e pontuais.
          </p>
          <p>
            Para conseguir isso, o processo de documentação que a UBC realiza em seu próprio banco de dados e no banco de dados do Ecad deve ser revisado e aprimorado continuamente.
          </p>
          <p>
            Um dos grandes desafios da era digital é o grande volume de novos dados, tanto para novos membros quanto para novos repertórios. É fundamental podermos processar regularmente os royalties não identificados e utilizar ferramentas de correspondência cada vez mais sofisticadas para acelerar o registro do repertório, o que, em última instância, permite o pagamento aos seus titulares de direitos.
          </p>
          <p>
            Como a UBC representa alguns dos maiores e mais ativos repertórios do mundo, tanto nacionais quanto internacionais, a infraestrutura interna e sua conexão com o Ecad estão em constante evolução para acompanhar a demanda, sem nunca sacrificar os serviços e recursos oferecidos a repertórios de todos os tipos e tamanhos.
          </p>
          <p>
            Os números a seguir se baseiam novamente nas informações do Ecad, para refletir de uma forma precisa o mercado brasileiro.
          </p>
        </div>
      </section>
      <section class="sectionRow top50">
        <div class="col23ponto5"></div>
        <div class="col66">
          <h4 class="h4Destaque">
            O valor total distribuído em 2022 foi de
            <span class="ubcPink Green sanukBlack">R$ 1.166.468.767,28</span> – 
            um
            <span class="ubcPink Green sanukBlack">crescimento de 37%</span> em
            relação ao ano anterior.
          </h4>
        </div>
      </section>
      <section class="sectionRow top120">
        <div class="col32">
          <h3>Evolução das cifras de distribuição</h3>
          <div class="evolucaoDistribuicao top20">
            <span>2018</span>
            <h4 class="sanukBlack ubcPink">R$ 971.684.647,69</h4>
          </div>
          <div class="evolucaoDistribuicao">
            <span>2019</span>
            <h4 class="sanukBlack ubcPink">R$ 986.558.369,74</h4>
          </div>
          <div class="evolucaoDistribuicao">
            <span>2020</span>
            <h4 class="sanukBlack ubcPink">R$ 947.928.688,22</h4>
          </div>
          <div class="evolucaoDistribuicao">
            <span>2021</span>
            <h4 class="sanukBlack ubcPink">R$ 851.660.776,76</h4>
          </div>
          <div class="evolucaoDistribuicao">
            <span>2022</span>
            <h4 class="sanukBlack ubcPink">R$ 1.166.468.767,28</h4>
          </div>
          <p class="top32">
            <span class="sanukBold"
              >316.201 titulares de direitos foram pagos</span
            >, dos quais
            <span class="sanukBold">35,7% eram titulares internacionais</span>,
            e <span class="sanukBold">64,3%, nacionais</span>, incluindo
            autores, compositores, editores, intérpretes, músicos e produtores.
          </p>
        </div>
        <div class="col57ponto6 topMob32">
          <h3>Participação na distribuição, por categoria </h3>
          <SwipperMobile />
          <div class="graphContainer">
            <div class="graph">
              <BarChart />
            </div>
          </div>
          <!-- <div class="top20">
            <PieChart2 />
          </div> -->
          <p class="note top20">
            Nota: os royalties arrecadados de Usuários Gerais para os quais não
            existem dados de uso disponíveis são somados às distribuições tanto
            de TV aberta como de Rádio, com um divisão de distribuição de
            5%/95%, respectivamente.
          </p>
          
        </div>
      </section>
      <section class="sectionRow top120">
        <div class="col100">
          <h3>
            Detalhamento da distribuição por tipo de direitos: autorais vs.
            conexos
          </h3>
          <SwipperMobile />
          <div class="top20 tableContainer">
            <table>
              <thead>
                <tr>
                  <th align="left">
                    <span class="sanukBold">Categorias</span>
                  </th>
                  <th colspan="3" align="center">
                    <span class="sanukBold">Autorais</span>
                  </th>
                  <th colspan="3" align="center">
                    <span class="sanukBold">Conexos</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td></td>
                  <td align="right" class="subColYear">2021</td>
                  <td align="right" class="subColYear">2022</td>
                  <td align="right" class="subColYear">%</td>
                  <td align="right" class="subColYear">2021</td>
                  <td align="right" class="subColYear">2022</td>
                  <td align="right" class="subColYear">%</td>
                </tr>
                <tr>
                  <td>TV aberta</td>
                  <td align="right">R$ 148.286.652,88</td>
                  <td align="right">R$ 163.670.360,65</td>
                  <td align="right">10,37%</td>
                  <td align="right">R$ 75.393.937,40</td>
                  <td align="right">R$ 98.892.378,37</td>
                  <td align="right">31,17%</td>
                </tr>
                <tr>
                  <td>Rádio</td>
                  <td align="right">R$ 117.626.849,22</td>
                  <td align="right">R$ 160.227.123,22</td>
                  <td align="right">36,22%</td>
                  <td align="right">R$ 56.188.013,27</td>
                  <td align="right">R$ 78.756.358,61</td>
                  <td align="right">40,17%</td>
                </tr>
                <tr>
                  <td>TV paga</td>
                  <td align="right">R$ 123.923.441,10</td>
                  <td align="right">R$ 122.746.817,80</td>
                  <td align="right">-0,95%</td>
                  <td align="right">R$ 55.695.734,88</td>
                  <td align="right">R$ 90.551.586,48</td>
                  <td align="right">62,58%</td>
                </tr>
                <tr>
                  <td>Vídeo sob demanda</td>
                  <td align="right">R$ 71.951.437,53</td>
                  <td align="right">R$ 119.505.311,95</td>
                  <td align="right">66,09%</td>
                  <td align="right">R$ 2.265.750,64</td>
                  <td align="right">R$ 6.716.472,95</td>
                  <td align="right">196,43%</td>
                </tr>
                <tr>
                  <td>Streaming (Áudio)</td>
                  <td align="right">R$ 55.596.577,36</td>
                  <td align="right">R$ 80.564.922,80</td>
                  <td align="right">44,91%</td>
                  <td align="right"></td>
                  <td align="right">R$ 186.057,01</td>
                  <td align="right"></td>
                </tr>
                <tr>
                  <td>Shows ao vivo</td>
                  <td align="right">R$ 20.249.196,66</td>
                  <td align="right">R$ 68.195.176,27</td>
                  <td align="right">236,78%</td>
                  <td align="right"></td>
                  <td align="right"></td>
                  <td align="right"></td>
                </tr>
                <tr>
                  <td>Música de fundo</td>
                  <td align="right">R$ 31.306.502,82</td>
                  <td align="right">R$ 38.491.740,57</td>
                  <td align="right">22,95%</td>
                  <td align="right">R$ 15.365.748,29</td>
                  <td align="right">R$ 20.462.661,98</td>
                  <td align="right">33,17%</td>
                </tr>
                <tr>
                  <td>Clubes</td>
                  <td align="right">R$ 11.899.605,74</td>
                  <td align="right">R$ 20.326.700,52</td>
                  <td align="right">70,82%</td>
                  <td align="right">R$ 9.037.772,33</td>
                  <td align="right">R$ 14.132.303,31</td>
                  <td align="right">56,37%</td>
                </tr>
                <tr>
                  <td>Cinema</td>
                  <td align="right">R$ 12.302.894,62</td>
                  <td align="right">R$ 12.536.432,83</td>
                  <td align="right">1,90%</td>
                  <td align="right">R$ 8.646.155,24</td>
                  <td align="right">R$ 15.946.101,78</td>
                  <td align="right">84,43%</td>
                </tr>
                <tr>
                  <td>Música ao vivo (pequenas casas de shows)</td>
                  <td align="right">R$ 11.011.377,46</td>
                  <td align="right">R$ 23.026.404,02</td>
                  <td align="right">109,11%</td>
                  <td align="right"></td>
                  <td align="right"></td>
                  <td align="right"></td>
                </tr>
                <tr>
                  <td>Carnaval</td>
                  <td align="right">R$ 11.229.778,48</td>
                  <td align="right">R$ 16.429.677,73</td>
                  <td align="right">46,30%</td>
                  <td align="right">R$ 780.258,20</td>
                  <td align="right">R$ 1.317.358,45</td>
                  <td align="right">68,84%</td>
                </tr>
                <tr>
                  <td>Festa Junina</td>
                  <td align="right">R$ 3.898.262,82</td>
                  <td align="right">R$ 3.032.997,46</td>
                  <td align="right">-22,20%</td>
                  <td align="right">R$ 191.922,88</td>
                  <td align="right">R$ 371.853,81</td>
                  <td align="right">93,75%</td>
                </tr>
                <tr>
                  <td>Outros serviços digitais*</td>
                  <td align="right">R$ 6.157.253,87</td>
                  <td align="right">R$ 6.182.587,23</td>
                  <td align="right">0,41%</td>
                  <td align="right">R$ 2.229.249,42</td>
                  <td align="right">R$ 2.978.722,89</td>
                  <td align="right">33,62%</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="tableNote" style="margin-bottom: 1rem">
            *=simulcast, websites e outros serviços que não se encaixam na definição de streaming
          </p>
          <p class="tableNote">Muito poucos serviços de streaming têm licença para direitos conexos, o que explica a ausência de distribuição em 2021 e a pequena quantidade de 2022. Shows e música ao vivo também não têm licenças para direitos conexos, pois não há uso de gravações em uma apresentação ao vivo.</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { ShareFunctions } from "../assets/js/functions.js";
// import PieChart2 from "./Grafico3.vue";
import BarChart from "./Grafico4.vue";
import SwipperMobile from "./SwipperMobile.vue";

export default {
  name: "DistribuicaoPage",
  props: ["clicked"],
  components: {
    // PieChart2,
    BarChart,
    SwipperMobile
     },
  data() {
    return {
      setaScrollState: false,
    };
  },
  destroyed() {
    this.myStopFunction();
  },
  mounted() {
    this.showSetaScroll();

    const conteudo = document.querySelector("#distribuicao");
    conteudo.addEventListener("scroll", ShareFunctions.headerScroll);
  },
  methods: {
    showSetaScroll: function () {
      this.refresh = setInterval(() => {
        let alturaTela = window.innerHeight;
        let alturaDiv = this.$refs.infoBox.clientHeight;
        let boxABB = this.$refs["infoscroll"].getBoundingClientRect();
        if (alturaTela - 50 <= alturaDiv && boxABB.top == 148) {
          this.setaScrollState = true;
        } else {
          this.setaScrollState = false;
        }
      }, 1000);
    },
    myStopFunction: function () {
      clearInterval(this.refresh);
    },
    goNext: function () {
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.evolucaoDistribuicao h4 {
  font-size: 24px;
  margin-bottom: 8px;
}
.evolucaoDistribuicao:nth-child(3) h4 {
  font-size: 27px;
  margin-bottom: 8px;
}
.evolucaoDistribuicao:nth-child(4) h4 {
  font-size: 30px;
  margin-bottom: 8px;
}
.evolucaoDistribuicao:nth-child(5) h4 {
  font-size: 33px;
  margin-bottom: 8px;
}
.evolucaoDistribuicao:nth-child(6) h4 {
  font-size: 36px;
}
.note {
  padding-left: 160px;
}

.graphContainer {
  padding-top: 30px;
  width: 100%;
  overflow-x: scroll;
}

.graphContainer::-webkit-scrollbar
{
  background-color: white;
  border-radius: 10px;
  width: 20px;
}

.graphContainer::-webkit-scrollbar-thumb
{
  background-color: #EC1651;
  border-radius: 10px;
  border: 5px solid white;
}

.tableNote {
  font-size: 12px;
  line-height: 18px;
}

.tableNote:first-of-type {
  margin-top: 20px;
  margin-bottom: unset;
}

.graph {
  min-width: 500px;
  min-height: 400px;
}

table {
  border: none;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
  font-size: 14px;
  min-width: 1024px;
}

table thead {
  background-color: #ec1651;
  color: #fff;
}

table thead tr th {
  padding: 15px 0;
  vertical-align: middle;
}

table thead tr th:first-child {
  padding-left: 2%;
}
table thead tr th:last-child {
  padding-right: 2%;
}

table tbody tr:nth-child(even) {
  background-color: #f6f6f6;
}

table tbody tr td {
  padding: 15px 0;
  vertical-align: middle;
  font-size: 12px;
}

table tbody tr {
  position: relative;
}

table tbody tr td:first-child {
  padding-left: 2%;
  position: sticky;
  left: 0;
  background: #fff;
}

table tbody tr:nth-child(even) td:first-child {
  background-color: #f6f6f6;
}

table tbody tr td:last-child {
  padding-right: 2%;
}

.tableNote {
  font-size: 12px;
  line-height: 18px;
}

.tableNote:first-of-type {
  margin-top: 20px;
  margin-bottom: unset;
}

.subColYear {
  font-family: "sanuk-bold";
  color: #ec1651;
}

@media screen and (max-width: 1200px) {
  .tableContainer{
    overflow-x: scroll;
  }
}

@media screen and (max-width: 500px) {
  .note {
    padding-left: 0;
  }
}
</style>
